import { Component, Input } from '@angular/core';
import { LeapV2Session } from '../models/leap-v2-session.model';
import { TutorCancelledDialogResult } from '../models/leap-v2-attendance.model';

@Component({
  selector: 'leap-v2-session-meta-card',
  templateUrl: './leap-v2-session-meta-card.component.html',
  styleUrls: ['./leap-v2-session-meta-card.component.css'],
  standalone: false,
})
export class LeapV2SessionMetaCardComponent {
  @Input() session: LeapV2Session;
  @Input() tutorCancelled = false;
  @Input() tutorCancelledSummary: TutorCancelledDialogResult | null = null;
}
